var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionMutedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0297 75.965C20.9375 72.2852 17.9855 67.8734 16.0513 63.1363C10.9209 50.5719 13.3232 35.6288 23.3399 25.3211L32.5829 34.5512C33.0919 35.0595 34.008 34.6936 34.1302 33.9413L39.1792 0.944452C39.2607 0.395521 38.7924 -0.0720876 38.2427 0.00923557L5.1796 5.05127C4.42631 5.17325 4.05985 6.08814 4.56883 6.59641L13.8322 15.8469C-1.45746 31.461 -4.06342 54.882 5.9736 73.1797C8.98675 78.6894 13.1604 83.7314 18.4741 87.9602C27.5135 95.137 38.6295 98.5729 49.6642 98.3492L51.7408 84.7886C42.2331 85.6018 32.4608 82.6742 25.0297 75.965Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5379 84.1531C101.828 68.539 104.433 45.118 94.3964 26.8203C91.3833 21.3106 87.2097 16.2686 81.896 12.0398C72.8566 4.86301 61.7405 1.42711 50.7059 1.65075L48.6293 15.2114C58.1166 14.3982 67.9093 17.3258 75.3404 24.0349C79.4325 27.7148 82.3846 32.1266 84.3187 36.8637C89.4492 49.4281 87.0468 64.3712 77.0302 74.6789L67.7872 65.4488C67.2782 64.9405 66.362 65.3064 66.2399 66.0587L61.1908 99.0555C61.1094 99.6045 61.5776 100.072 62.1273 99.9908L95.1905 94.9487C95.9437 94.8267 96.2898 93.9118 95.8012 93.4036L86.5379 84.1531Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionMutedGrey);
export default __webpack_public_path__ + "static/media/subscription-muted-grey.7c3f108903d3634f2e4a2ed9be4b9401.svg";
export { ForwardRef as ReactComponent };